export enum CacheKeys {
  EAD = 'ead',
  ARCHIVAL_AID = 'aid',
  ARCHIVAL_UNIT = 'archival-unit',
  ARCHIVAL_COLLECTION = 'archival-collection',
  ORIGINATOR = 'originator',
  AID_LIST = 'aid-list',
  COLLECTION_LIST = 'collection-list',
  AID_LIST_BY_ORIGINATOR = 'aid-list-by-originator',
  COLLECTION_LIST_BY_ORIGINATOR = 'collection-list-by-originator',
}
